import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: 0,
    height: 80,
    width: '100%',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.background.paper,
    cursor: 'pointer',
    textDecoration: 'none',
  },
  colorPending: {
    background: theme.palette.submissionStatuses.review,
  },
  colorApproved: {
    background: theme.palette.submissionStatuses.approved,
  },
  colorRejected: {
    background: theme.palette.submissionStatuses.rejected,
  },
  colorFlagged: {
    background: theme.palette.submissionStatuses.flagged,
  },
  leftContainer: {
    flexGrow: 1,
    minWidth: 0,
    height: '100%',
  },
  statusColor: {
    width: 4,
    height: 80,
    flexShrink: 0,
  },
  imageContainer: {
    height: '100%',
    flexShrink: 0,
    display: 'flex',
    alignSelf: 'stretch',
  },
  attachedImage: {
    objectFit: 'cover',
    height: '100%',
    width: 80,
  },
  textContainer: {
    marginLeft: theme.spacing(3),
    overflow: 'hidden',
    flexGrow: 1,
    maxWidth: 300,
    minWidth: 0,
    [theme.breakpoints.down('lg')]: {
      marginLeft: theme.spacing(2),
    },
    [theme.breakpoints.down('md')]: {
      marginLeft: theme.spacing(1),
    },
  },
  dateAndType: {
    color: theme.palette.text.secondary,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  submissionTitle: {
    color: theme.palette.text.primary,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));
